import React, { Component } from "react";
import {
  storyTemplates,
  checkUploadType,
  uploadPreview,
  matchUrl,
  wordFilter,
  createUrlLink,
  createMentionUrl,
  checkValidityForAnonymousToggleEdit,
} from "../../utils/constants";
// import { MentionsInput, Mention } from 'react-mentions'
import defaultCreateStory from "../../pages/stories/defaultCreateStory";
import defaultMobileCreateStory from "../../pages/stories/defaultMobileCreateStory";
import defaultMentionStyle from "../../pages/stories/defaultMentionStyle";
import {
  Row,
  Col,
  Button,
  Label,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Modal,
} from "reactstrap";
import Toggle from "react-toggle";
import axios from "../../axios";
import * as url from "../../utils/url";
import classnames from "classnames";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { isMobile } from "../../utils/deviceInfo";
import If from "../Shared/If";
import { ReactTinyLink } from "react-tiny-link";
import * as actionCreators from "../../modules/actions/index";
// import ReactPlayer from 'react-player'
import ReactPlayer from "react-player/lazy";
import StoryMentionsText from "./StoryMentionsText";
import Loading from "../../hoc/Loading/Loading";
import { sortBy } from "lodash";
import UserSearchAndSelectComponent from "../UserSearchAndSelectComponent/UserSearchAndSelectComponent";

class EditStory extends Component {
  mentionsTextRef = React.createRef();
  constructor(props) {
    super(props);
    const hideAnonymous =
      props.user.profile && props.user.profile.organizationId.disableAnonymity
        ? checkValidityForAnonymousToggleEdit(
            props.story.createdOn,
            props.story.isAnonymous,
            "cultureApp",
            props.user.profile.organizationId.disableAnonymity
          )
        : false;

    console.log(hideAnonymous);

    this.state = {
      mentionsText: "",
      story: this.props.story,
      isListFound: false,
      topics: [],
      title: "",
      //add copied
      description: {
        // value:
        //   this.props.story &&
        //   this.props.story.sanitizedDescription &&
        //   this.props.story.sanitizedDescription.value
        //     ? this.props.story.sanitizedDescription.value
        //     : "",
        value:
          this.props.story && this.props.story.description
            ? this.props.story.description
            : "",
      },

      isBadWords: "",
      // urlScrape: false,
      disableCreate: false,
      imageError: null,

      setImagesPreview: [],
      rejectedFiles: [],

      isListFound: false,
      isListChecked: false,
      isListVisible: true,
      disableSubmit: true,
      sanitizedDescription: null,
      privacy: "PUBLIC",
      isAnonymous: false,
      isAnonymousVisible: !hideAnonymous,
      topicAlert: false,
      isDescription: null,
      showReplies: false,
      topicsSelected: [],
      updatedFields: [],
      mentionData: [],
      rawText: "",
      newValue: "",
      ogp: {
        urlScrape: false,
        requestUrl: "",
        // urlScrape:false,
        // ogImage:"",
        // ogDesc:"",
        // ogTitle:"",
        // ogType:"",
        // ogUrl:"",
        // ogSiteName:"",
        // extra:{}
      },
      privacy: "PUBLIC",
      selectedStoryTemplate: null,
      sharedWithUsers: [],
    };
  }

  selectStoryTemplate = (template) => {
    this.setState({ selectedStoryTemplate: template });
  };

  componentDidMount() {
    let orgId = this.props.user.profile.organizationId._id;
    let id;
    if (this.props.storyId) {
      id = this.props.storyId;
    } else {
      id = this.props.match.params.id;
    }

    let userId = this.props.user.profile._id;
    this.grabStoryContent(orgId, id, userId);
    this.processData(this.state.story);
    this.getTopics(orgId);

    axios.get(url.getMailer(orgId)).then(({ data }) => {
      this.setState({ isListFound: data.data.listFound });
    });

    axios.get(url.getMailer(orgId)).then(({ data }) => {
      this.setState({ isListFound: data.data.listFound });
    });

    axios.get(url.findOrgById(orgId)).then(({ data }) => {
      const payload = data.data;
      this.props.orgChangeSuccess(payload);
    });
  }

  processData = (storyDoc) => {
    const story = { ...storyDoc };
    const imgPreview = story.attachments && Array.isArray(story.attachments) ? story.attachments.map((x, index) => {
      return {
        ...x,
        isAccepted: true,
        previous: true,
        preview: uploadPreview({ ...x, type: x.type.mime }).preview || x.url,
        type: x.type.mime,
        typeObj: x.type,
      };
    }):[]

    let rawVal = "";
    let newVal = "";
    if (story.mentionData && story.mentionData.length > 0) {
      //storyDesc = story.mentionsText;
      newVal = story.mentionData[0].newValue;
      rawVal = story.mentionData[0].newPlainTextValue;
    } else {
      //storyDesc = story.sanitizedDescription.value
      //  .replace(/\<span>/g, "")
      //  .replace(/\<span>/g, "");
      // .replace(/<[^>]*>/g, "");
      rawVal = story.sanitizedDescription.value
        .replace("<span>", "")
        .replace("</span>", "");
      // .replace(/<[^>]*>/g, "");
    }
    this.setState({
      story: { ...story },
      description: {
        value:
          story &&
          story.sanitizedDescription &&
          story.sanitizedDescription.storyMention
            ? story.sanitizedDescription.storyMention
            : story.description
                .replace(/\<span>/g, "")
                .replace(/\<\/span>/g, "")
                .replace(/\<a[^>]*>/g, "")
                .replace(/\<\/a>/g, ""),
      },

      topicsSelected: story.topics || [],
      isAnonymous: story.isAnonymous,
      setImagesPreview: imgPreview,
      selectedStoryTemplate: story.template,
      mentionData: story.mentionData || [],
      mentionsText: story.mentionsText || "",
      ogp: story.ogp ? story.ogp : { urlScrape: false, requestUrl: "" },
      rawText: rawVal,
      newValue: newVal,
      selectedStoryTemplate: story.template,
      sharedWithUsers: story.sharedWith,
      privacy: story.privacy,
    });
  };

  grabStoryContent = (orgId, id, userId) => {
    axios
      .get(url.getSingleStory(id))
      .then((res) => {
        console.log("resStory----", res);
        this.processData(res.data.data[0]);
      })
      .catch((err) => console.log(err));
  };

  getTopics = (orgId) => {
    if (!this.props.user) return;
    axios.get(url.getTopics(orgId)).then(({ data }) => {
      // console.log("data---", data.data)
      let topics = data.data;
      this.setState({
        topics: [...topics],
      });
    });
  };

  canSubmit = (val) => {
    this.setState({ ...val });
  };

  fileSelectedHandler = (e) => {
    let { setImagesPreview } = this.state;
    this.setState({ imageError: null });
    if (e.target.files) {
      let arr = [];
      let fileArr = Array.from(e.target.files).map((file, idx) => {
        let obj = {
          name: file.name,
          type: file.type,
          size: file.size,
          file,
          preview: URL.createObjectURL(file),
          isAccepted: checkUploadType(file.type),
          newUploaded: true,
        };
        return uploadPreview(obj);
      });

      let acceptedFiles = fileArr.filter((e) => e.isAccepted == true);
      //   .map(e=>{
      // 	delete e.isAccepted
      // 	return e
      //   })
      let rejectedFiles = fileArr.filter((e) => e.isAccepted == false);
      let allUploads = acceptedFiles.concat(rejectedFiles);

      let acceptedLength = setImagesPreview.length + acceptedFiles.length;
      if (acceptedLength < 6) {
        this.setState((prevState) => ({
          setImagesPreview: prevState.setImagesPreview.concat(acceptedFiles),
          rejectedFiles: prevState.rejectedFiles.concat(rejectedFiles),
        }));
        Array.from(e.target.files).map((file) => URL.revokeObjectURL(file));
      } else {
        this.setState({
          imageError: 2,
        });
      }
    }
  };

  storyTopicSelect = (topic) => {
    let { topicsSelected } = this.state;
    this.setState({ topicAlert: false });
    // console.log(topicsSelected, topic)
    if (topicsSelected.findIndex((x) => x._id === topic._id) > -1) {
      this.setState((prevState) => ({
        topicsSelected: topicsSelected.filter((e) => e._id !== topic._id),
      }));
    } else {
      // console.log("topic----")
      if (topicsSelected.length < 4) {
        this.setState((prevState) => ({
          topicsSelected: [...prevState.topicsSelected, topic],
        }));
      } else {
        this.setState({ topicAlert: true });
      }
    }
  };

  handlePermissionChange = (changeEvent) => {
    this.setState({
      isAnonymous: changeEvent.target.checked,
    });
  };

  handleSelectUsers = (users) => {
    const data = users.map((x) => ({
      _id:x._id || x.userId,
      userId: x._id||x.userId,
      firstName: x.firstName,
      lastName: x.lastName,
      profilePic: x.profilePic,
    }));
    this.setState({ sharedWithUsers: [...data] });
  };

  handleChangeEmailList = (el) => {
    this.setState({
      isListChecked: el.target.checked,
    });
  };

  renderUploadPreview = (source) => {
    let { rejectedFiles } = this.state;
    // if(rejectedFiles && rejectedFiles.length>0){
    //  source = source.concat(rejectedFiles)
    // }

    return source.map((photo, idx) => {
      let { preview, size } = photo;
      let mb = 1024 * 1024;
      let file_size =
        size >= mb
          ? `${(size / mb).toFixed(2)}mb`
          : `${(size / 1024).toFixed(2)}kb`;
      return (
        <span
          key={idx}
          className={
            photo.isAccepted == false
              ? "storyUploadPreviewImg rejectedFilesContainer"
              : "storyUploadPreviewImg"
          }
        >
          {photo.type && photo.type.indexOf("video") > -1 ? (
            <ReactPlayer
              url={preview}
              // controls={true}
              width="125px"
              height="69px"
            />
          ) : (
            <img src={preview} className="fileUploadSize" />
          )}
          <span
            key={preview + idx}
            onClick={() => this.removeImage(photo)}
            className="removeTaskUpload"
          >
            <span className="flaticon-trash" />
          </span>
          <div className="">
            <span className="previewTaskImageTitle">{photo.name}</span>
            <span className="previewTaskImageTitle">{file_size}</span>
            {/* {photo.isAccepted==false?
					<span className="previewUploadFileError">
					  The following file will not be uploaded because of its file type
					</span>
					:null} */}
          </div>
        </span>
      );
    });
  };

  removeImage = (photo) => {
    let { setImagesPreview } = this.state;
    let { preview } = photo;
    setImagesPreview.map((el) => URL.revokeObjectURL(el.file));
    let result = setImagesPreview.filter((e) => e.preview != preview);
    URL.revokeObjectURL(preview);
    URL.revokeObjectURL(photo.file);
    this.setState({ setImagesPreview: result });
  };

  handleFileRemove = (photo) => {};

  handleFileAdd = () => {};

  componentDidUpdate(prevProps, prevState) {
    const {
      updatedFields,
      story,
      setImagesPreview,
      selectedStoryTemplate,
      sharedWithUsers,
    } = this.state;
    if (prevState.description.value !== this.state.description.value) {
      const descText =
        story.mentionData && story.mentionData.length
          ? story.mentionsText
          : story.description;
      if (
        this.state.description.value &&
        descText
          .replace("<span>", "")
          .replace("</span>", "")
          .replace(/<[^>]*>/g, "") === this.state.description.value
      ) {
        const arr = updatedFields.filter((x) => x !== "description");

        this.setState({ updatedFields: arr });
      } else {
        if (!updatedFields.includes("description")) {
          updatedFields.push("description");
          this.setState({ updatedFields });
        }
      }
    }

    if (
      JSON.stringify(prevState.topicsSelected) !==
      JSON.stringify(this.state.topicsSelected)
    ) {
      const sortedStoryTopics = sortBy(story.topics || [], (x) => x.name).map(
        (y) => y._id
      );
      const sortedStateTopics = sortBy(
        this.state.topicsSelected,
        (x) => x.name
      ).map((y) => y._id);

      if (
        JSON.stringify(sortedStateTopics) !== JSON.stringify(sortedStoryTopics)
      ) {
        if (!updatedFields.includes("topics")) {
          updatedFields.push("topics");
          this.setState({ updatedFields });
        }
      } else {
        const arr = updatedFields.filter((x) => x !== "topics");

        this.setState({ updatedFields: arr });
      }
    }

    if (prevState.isAnonymous != this.state.isAnonymous) {
      if (story.isAnonymous !== this.state.isAnonymous) {
        if (!updatedFields.includes("isAnonymous")) {
          updatedFields.push("isAnonymous");
          this.setState({ updatedFields });
        }
      } else {
        const arr = updatedFields.filter((x) => x !== "isAnonymous");

        this.setState({ updatedFields: arr });
      }
    }

    if (
      JSON.stringify(prevState.setImagesPreview) !==
      JSON.stringify(setImagesPreview)
    ) {
      let attachmentChanged = false;

      console.log({ prev: prevState.setImagesPreview, setImagesPreview });

      const changedData = setImagesPreview.filter((x) => !x.previous);

      if (
        changedData.length > 0 ||
       ( story.attachments && setImagesPreview.length !== story.attachments.length )
      ) {
        attachmentChanged = true;
      } else {
        attachmentChanged = false;
      }

      if (attachmentChanged) {
        if (!updatedFields.includes("uploads")) {
          updatedFields.push("uploads");
          this.setState({ updatedFields });
        }
      } else {
        const arr = updatedFields.filter((x) => x !== "uploads");

        this.setState({ updatedFields: arr });
      }
    }

    if (
      prevState.selectedStoryTemplate &&
      selectedStoryTemplate._id !== prevState.selectedStoryTemplate._id
    ) {
      if (story.template._id !== selectedStoryTemplate._id) {
        if (!updatedFields.includes("template")) {
          updatedFields.push("template");
          this.setState({ updatedFields });
        }
      } else {
        const arr = updatedFields.filter((x) => x !== "template");

        this.setState({ updatedFields: arr });
      }
    }

    if (
      prevState.sharedWithUsers &&
      JSON.stringify(prevState.sharedWithUsers) !==
        JSON.stringify(sharedWithUsers)
    ) {
      if(JSON.stringify(story.sharedWith) !== JSON.stringify(sharedWithUsers)){
        if (!updatedFields.includes("sharedWith")) {
          updatedFields.push("sharedWith");
          this.setState({ updatedFields });
        }
      }else{
        const arr = updatedFields.filter((x) => x !== "sharedWith");

        this.setState({ updatedFields: arr });
      }
    }
  }

  handleSubmit = () => {
    console.log("updated", this.state.updatedFields);
    let {
      description,
      isAnonymous,
      mentionData,
      sanitizedDescription,
      isListChecked,
      privacy,
      title,
      mentionsSelected,
      topicsSelected,
      ogp,
      setImagesPreview,
      updatedFields,
      selectedStoryTemplate,
      sharedWithUsers,
      
    } = this.state;

    const formData = new FormData();
    let isMention;

    let payload = {
      existing_files: [],
    };

    if (
      updatedFields.includes("template") ||
      (selectedStoryTemplate && selectedStoryTemplate != null)
    ) {
      formData.append("template", selectedStoryTemplate);
      payload.template = selectedStoryTemplate;
    }

    payload.email_text_length = 300
    formData.append("email_text_length", 300);

    if (updatedFields.includes("description")) {
      let cleanDesc = description.value ? wordFilter(description.value) : false;

      if (cleanDesc.length == 0) {
        description.value = createUrlLink(description.value);
        description.value = createMentionUrl(
          description.value,
          this.props.user.profile
        );
        let desc = `<span>${description.value}</span>`;
        payload.description = desc;

        formData.append("description", desc);
        formData.append("mentionData", mentionData);

        if (
          this.props.story &&
          this.props.story.ogp &&
          this.props.story.ogp.ogUrl &&
          this.props.story.ogp.ogUrl != ogp.ogUrl
        ) {
          formData.append("ogp", ogp);
          payload.ogp = ogp;
        }

        if (
          mentionData &&
          mentionData.mentions &&
          mentionData.mentions.length > 0
        ) {
          payload.mentionData = mentionData;
          let { mentions } = mentionData;
          isMention = true;
          sanitizedDescription.userReferences = mentions.map((e) => e.id);
          payload.users = mentions.map((e) => ({
            _id: e.id,
            organizationId: this.props.user.profile.organizationId._id,
          }));
          formData.append("users", mentions);
          payload.mentionsText = mentionData.newValue;
          formData.append("mentionsText", mentionData.newValue);
        }

        if (matchUrl(description.value)) {
          payload.isUrl = true;
          formData.append("isUrl", true);
        }

        // payload.isUrl = isUrl
        // formData.append('isUrl', isUrl);
        payload.isCustomList = isListChecked;

        payload.isMention = isMention;
        formData.append("isMention", isMention);

        payload.sanitizedDescription = sanitizedDescription;
        formData.append("sanitizedDescription", sanitizedDescription);
      } else {
        this.setState({ disableCreate: false });

        if (description && description.value && description.value.length == 0) {
          this.setState({ isDescription: "No description" });
        }

        if (cleanDesc && cleanDesc.length > 0) {
          this.setState({ isBadWords: cleanDesc });
        }

        return;
      }
    }

    if (updatedFields.includes("isAnonymous")) {
      payload.isAnonymous = isAnonymous;
      formData.append("isAnonymous", isAnonymous);
    }

    if (updatedFields.includes("topics")) {
      payload.topics = topicsSelected;
      formData.append("topics", payload.topics);
    }

    if(updatedFields.includes("sharedWith")){
      payload.sharedWith = sharedWithUsers;
      formData.append("sharedWith", payload.sharedWith);
    }

    formData.append("privacy",privacy)
    payload.privacy = privacy

    if (updatedFields.includes("uploads")) {
      if (setImagesPreview && setImagesPreview.length > 0) {
        let sorted = setImagesPreview.sort(function(a, b) {
          return b.size - a.size;
        });
        Array.from(sorted).forEach((itm) => {
          delete itm.isAccepted;
          if (itm.newUploaded) {
            formData.append("uploaded_files", itm.file);
          } else {
            formData.append("existing_files", itm);
            payload.existing_files.push({ ...itm, type: itm.typeObj });
          }
        });
      }
    }

    payload.storyType = formData.append("payload", JSON.stringify(payload));

    console.log("payload-payload-payload-payload-payload", payload);

    axios
      .post(url.editStory(this.state.story._id), formData)
      .then(({ data }) => {
        // console.log(data.data, data.data.data)
        let story = data.data;
        // console.log('story----', story)

        // this.props.storyMetricsChange({ type: "story", value: 1 });
        //Call back to update parent compoent when stopry is edited
        this.props.onEditSuccess(story,false);

        this.props.toggleEditPopup();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  selectStoryTemplate = (data) => {
    this.setState({ selectedStoryTemplate: data });
  };

  render() {
    const createStoryModalStyle = classnames(
      "profile-modal-save-btn float-left",
      {
        disabled: this.state.disableSubmit,
        disabledBtn: this.state.disableSubmit,
        weeklyWinBtn: !isMobile,
        "btn-block": isMobile,
      }
    );
    const { editPopupOpen, toggleEditPopup, isComment } = this.props;
    const {
      story,
      disableCreate,
      rejectedFiles,
      setImagesPreview,
      selectedStoryTemplate,
      imageError,
      topicAlert,
      topicsSelected,
      isAnonymous,
      isDescription,
      isListFound,
      isListChecked,
      topics,
      disableSubmit,
      isAnonymousVisible,
      sharedWithUsers,
    } = this.state;

    return (
      <div className="edit-story-popup">
        {console.log(isAnonymousVisible)}
        <Modal isOpen={editPopupOpen}>
          <ModalHeader toggle={toggleEditPopup}>
            Edit {isComment ? "Comment" : "Story"}
          </ModalHeader>
          {console.log(this.state.updatedFields)}
          <ModalBody className="create-stories">
            <div className={disableCreate ? "disableCreateStory" : ""}>
              {!isComment && (
                <div
                  className={`stories_template_items_container mb-5 ${
                    isMobile ? "mobile-scroll-storytype" : ""
                  }`}
                >
                  {storyTemplates.map((e, idx) => {
                    return (
                      <div
                        className={
                          !isMobile
                            ? "storyContainer"
                            : "storyContainer mobile-edit-storytype"
                        }
                        style={{
                          paddingRight:
                            e._id == "template_other_01" ? "0px" : "",
                        }}
                        key={idx}
                      >
                        <div
                          className={`storyTemplate ${
                            selectedStoryTemplate &&
                            selectedStoryTemplate._id == e._id
                              ? "selected-template-edit"
                              : "not-selected "
                          }`}
                          style={{ backgroundColor: e.color, border: e.border }}
                          onClick={() => this.selectStoryTemplate(e)}
                        >
                          <img src={e.image} className="templateImage" />
                          {e.name}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              <StoryMentionsText
                canSubmit={this.canSubmit}
                // storyType={story && story.template.placeholder}
                storyType={story && story.type}
                ref={this.mentionsTextRef}
                value={this.state.description}
                description={this.state.description}
                mentionDataValue={this.state.mentionData}
                rawTextValue={this.state.rawText}
                ogpData={this.state.ogp}
                newTextValue={this.state.newValue}
              />

              {rejectedFiles && rejectedFiles.length > 0 ? (
                <div className="rejectedFilesContainer">
                  <span className="">
                    The following file(s) will not be uploaded because of the
                    file type:
                  </span>
                  &nbsp;
                  {rejectedFiles.map((e, idx) => {
                    let name =
                      idx == rejectedFiles.length - 1
                        ? e.name + "."
                        : e.name + ", ";
                    return name;
                  })}
                </div>
              ) : null}

              <div>
                {setImagesPreview && setImagesPreview.length > 0 ? (
                  <div className="taskUploadPreviewContainer mb0">
                    <div className="taskUploadPreviewContainerOverflow">
                      {this.renderUploadPreview(setImagesPreview)}
                    </div>
                  </div>
                ) : null}
              </div>

              <div className="singleTaskUploadModalBtn">
                <label
                  htmlFor="profile-pic-file-input"
                  style={{ marginBottom: "0px" }}
                >
                  <span
                    className={`actionsByStatus singleTaskUpload ${
                      disableCreate ? "opacity40" : ""
                    }`}
                    style={{ color: "white" }}
                  >
                    <span className="flaticon-upload" />
                    Upload files
                  </span>
                </label>
                <input
                  id="profile-pic-file-input"
                  onClick={!disableCreate ? this.handleClick : null}
                  onChange={this.fileSelectedHandler}
                  type="file"
                  multiple
                />

                {imageError == 2 ? (
                  <span className="errorMsg">
                    Too many files. Max 5 files allowed.
                  </span>
                ) : (
                  <span className="maxUploadTxt">
                    Attach up to 5 files. Upload any media type (jpg, png,
                    video), office file type (word, excel, csv, powerpoint),
                    and/or pdf.  <b>(Note* Maximum file size is 20MB)</b> 
                  </span>
                )}

                <span>
                  
                </span>
              </div>

              <div>
                <Col
                  md={12}
                  lg={12}
                  className={`${isMobile && "pb-150"} pl-0 stories-toggle`}
                >
                  {!isComment && (
                    <div>
                      <span className="storyTopicsModalTitle">Topics</span>

                      {this.state.topicAlert ? (
                        <div className="topicAlert">
                          Please only select 3 topics. To select another topic,
                          deselect one of your current selections
                        </div>
                      ) : null}

                      {topics && topics.length > 0 ? (
                        <div className="storyTopicsModal">
                          {topics.map((topic, idx) => {
                            return (
                              <div
                                className="storyGroupContainer"
                                onClick={() => this.storyTopicSelect(topic)}
                                key={idx}
                              >
                                <div
                                  className={
                                    topicsSelected.findIndex(
                                      (x) => x.name === topic.name
                                    ) > -1
                                      ? "storyGroupsModalSelected"
                                      : "storyGroupsModal"
                                  }
                                >
                                  {topic.name}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ) : null}
                    </div>
                  )}

                  <Row>
                    <Col>
                      <div
                        className="toggle-switch anonymousStory mt-3"
                        hidden={!isAnonymousVisible}
                      >
                        <span className="ml10">
                          <Toggle
                            checked={isAnonymous}
                            icons={false}
                            onChange={this.handlePermissionChange}
                          />
                        </span>
                        <span className="permission-value ml10">Anonymous</span>
                      </div>

                      {isDescription === ""
                        ? "Please include a description"
                        : null}

                      <If condition={isMobile}>
                        <div className="mt-4">
                          {this.state.isBadWords.length > 0 ? (
                            <span className="badwords">
                              {" "}
                              There appears to be a profane or insensitive word
                              in your post:{" "}
                              <strong>
                                {this.state.isBadWords.join(", ")}
                              </strong>
                              . Please remove them and try posting your story
                              again.
                              {/* Please contact us at <a href="mailto:support@ouroffice.io "> support@ouroffice.io </a> if you continue to have a problem. */}
                            </span>
                          ) : null}
                        </div>
                      </If>
                    </Col>
                  </Row>

                  <div className="mt-5 mb-0 select-shared-with-users">
                    <UserSearchAndSelectComponent
                      selectedUsers={sharedWithUsers}
                      handleSelectUsers={this.handleSelectUsers}
                      label={"Only share with"}
                      privacy={this.state.privacy}
                      changePrivacy={(val) => {
                        this.setState({ privacy: val });
                      }}
                      isEdit
                    />
                  </div>

                  {isListFound != false && this.props.user.orgAdmin ? (
                    <div className="mt40 noPadding">
                      <div className="" hidden={!this.state.isListVisible}>
                        <span className="">
                          <Toggle
                            checked={isListChecked}
                            icons={false}
                            onChange={this.handleChangeEmailList}
                          />
                        </span>
                        <span className="permission-value ml10">
                          Send to custom email list ?
                        </span>
                      </div>
                    </div>
                  ) : null}
                </Col>
              </div>

              <div className={`storyModalSubmitContainer`}>
                <If condition={true}>
                  {this.state.isBadWords.length > 0 ? (
                    <span className="badwords">
                      {" "}
                      There appears to be a profane or insensitive word in your
                      post: <strong>{this.state.isBadWords.join(", ")}</strong>.
                      Please remove them and try posting your story again.
                      {/* Please contact us at <a href="mailto:support@ouroffice.io "> support@ouroffice.io </a> if you continue to have a problem. */}
                    </span>
                  ) : null}
                </If>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              className="profile-modal-save-btn float-left weeklyWinBtn"
              onClick={this.handleSubmit}
              disabled={!this.state.updatedFields.length}
            >
              <span className="profile-modal-save-btn-txt">
                {isMobile ? "Save" : "Save Edit"}

                <span className="ml10 flaticon-tick"></span>
              </span>
            </Button>
            <Button
              className="profile-modal-cancel-btn float-right weeklyWinBtn"
              onClick={toggleEditPopup}
            >
              <span className="profile-modal-cancel-btn-txt">Cancel</span>
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(EditStory, axios));
